import React, { FC, ReactNode, useEffect, useRef } from "react";
import { GrowthBookProvider as GBProvider } from "@growthbook/growthbook-react";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { useDeviceType } from "@UI/hooks/useDeviceType";
import { getLocale } from "@I18n/services/i18n";
import { gb, getBackendVisitorId } from "../services/growthbook";

interface Props {
  children: ReactNode;
}

export const GrowthBookProvider: FC<Props> = ({ children }) => {
  const { currentUser } = useCurrentUser();
  const deviceType = useDeviceType();
  const locale = getLocale();
  const initialized = useRef(false);

  useEffect(() => {
    gb.setAttributes({
      id: currentUser?.id?.toString() || getBackendVisitorId(),
      loggedIn: !!currentUser,
      locale,
      deviceType,
      isSubscribed: currentUser?.subscribed ?? false,
      isProClient: currentUser?.proClient ?? false,
    });

    if (!initialized.current) {
      initialized.current = true;
      gb.init({ streaming: true }).catch(() => undefined);
    }
  }, [currentUser, deviceType, locale]);

  return <GBProvider growthbook={gb}>{children}</GBProvider>;
};
